import './style.css';

const BtnWebsiteLink = ({link}) => {
  return ( 
    <a href={link} target="_blank" rel="noreferrer" className="btn-outline">

      Go To Website
    </a>
   );
}
 
export default BtnWebsiteLink;